import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../services/api';
import socket from '../socket'; // Import the shared socket instance
import { FaUsers, FaCircle } from 'react-icons/fa';
import '../css/OnlineUsers.css'; // Import styles for consistent badge appearance

const OnlineUsersBadge = () => {
  const [onlineCount, setOnlineCount] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Fetch online users count
  const fetchOnlineCount = async () => {
    const userString = localStorage.getItem('user');
    if (!userString) return;

    let currentUser = null;
    try {
      currentUser = JSON.parse(userString);
    } catch {
      return;
    }

    if (currentUser?.role !== 'SUPER_ADMIN') return;

    try {
      const response = await API.get('/user-activity/stats', {
        timeout: 10000,
        retry: 0,
        skipErrorInterceptorLog: true
      });
      setOnlineCount(response.data.onlineCount);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        return;
      }
      const isTransient = (
        err?.code === 'ERR_NETWORK'
        || err?.code === 'ECONNABORTED'
        || [502, 503, 504].includes(err?.response?.status)
      );
      if (!isTransient) {
        console.error('Error fetching online users count:', err);
      }
    }
  };

  // Initial data load
  useEffect(() => {
    fetchOnlineCount();

    // Set up refresh interval
    const interval = setInterval(() => {
      fetchOnlineCount();
    }, 60000); // Refresh every minute

    return () => clearInterval(interval);
  }, []);

  // Listen for WebSocket events
  useEffect(() => {
    const handleRoleNotification = (data) => {
      if (data.type === 'user_connected' || data.type === 'user_disconnected') {
        fetchOnlineCount();
      }
    };

    // Subscribe to events
    socket.on('roleNotification', handleRoleNotification);

    return () => {
      // Unsubscribe from events
      socket.off('roleNotification', handleRoleNotification);
    };
  }, []);

  return (
    <Link
      to="/online-users"
      className="online-users-badge-modern"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={`${onlineCount} người dùng đang trực tuyến`}
    >
      <div className="online-badge-container">
        {/* Live indicator with pulse */}
        <div className="online-indicator">
          <FaCircle className="pulse-dot" />
        </div>

        {/* Users icon */}
        <FaUsers className="online-users-icon" />

        {/* Count badge */}
        <span className="online-count-badge">
          {onlineCount}
        </span>

        {/* Tooltip on hover */}
        {isHovered && (
          <div className="online-tooltip">
            <span>{onlineCount} đang online</span>
          </div>
        )}
      </div>
    </Link>
  );
};

export default OnlineUsersBadge;
